module.exports = __webpack_public_path__ + "static/media/cont613.cb7a84c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont613.mp4
// module id = YDOF
// module chunks = 0